import React, { PureComponent } from 'react';
//import PropTypes from 'prop-types';
import { Col } from 'antd';
import ThGrid from './ThGrid';

class ColumnHeader extends PureComponent {
    render() {
        const column = this.props.data;
        return (
            <div>
                {
                    column.map(val => {
                        return <Col {...val.colProps} key={val.key}>
                            <ThGrid>
                                {val.title}
                            </ThGrid>
                        </Col>
                    })
                }
            </div>
        );
    }
}

ColumnHeader.propTypes = {

};

export default ColumnHeader;